/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  LinearProgress,
  FormGroup,
  FormLabel,
  FormControl,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  Grid,
  Card,
  CardContent,
  Switch,
} from "@material-ui/core";

import { Add, Edit, ArrowForward, KeyboardArrowDown } from "@material-ui/icons";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import moment from "moment";
import componentStyles from "assets/theme/views/auth/login";
import Api from "lib/api/httpRequestHelper";
import { DialogCreateOccurence } from "./DialogCreateOccurence";
import { TableRegistroProblemaPI } from "views/pedidos/table/TableRegistroProblemaPI";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useCardStyles = makeStyles((theme) => ({
  cardRoot: {
    margin: "0.5rem 0 1rem",
  },
  cardContentRoot: {
    padding: "0.5rem 1.5rem !important",
  },
}));

function DialogRegistroProblemaPI({ open, handleClose, idPedido, idLoja }) {
  const classes = {
    ...useStyles(),
    ...useCardStyles(),
  };
  const snackbar = useSnackbar();
  const isMobile = IsMobile();

  const [motive, setMotive] = useState("");
  const [problemType, setProblemType] = useState("");
  const [description, setDescription] = useState("");
  const [responsable, setResponsable] = useState("");
  const [listProblemTypes, setListProblemsTypes] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [verifyStatus, setVerifyStatus] = useState([]);

  const [registering, setRegistering] = useState(false);
  const [openCreateProblem, setOpenCreateProblem] = useState(false);

  const [loadingProblemOperationList, setLoadingProblemOperationList] =
    useState(true);
  const [problemsOperationList, setProblemsOperationList] = useState([]);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const [updating, setUpdating] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [hasChange, setHasChange] = useState(false);
  const [validationButton, setValdationButton] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [occurences, setOccurences] = useState([]);
  const [openCreateOccurence, setOpenCreateOccurence] = useState(false);
  const [editOccurence, setEditOccurence] = useState(null);
  const [loadingProblem, setLoadingProblem] = useState(false);

  const FormTextInput = ({ label, disable, value }) => {
    return (
      <FormGroup>
        <FormLabel>{label}</FormLabel>
        <TextField disabled={disable} value={value} variant="outlined" />
      </FormGroup>
    );
  };

  const fetchTypeProblemsAndStatus = async () => {
    await Api.get("parameters-operation-problem", "configuracoesOmni", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setListProblemsTypes(Result?.TipoProblema);
          setStatusList(Result?.StatusProblema);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  };

  const fetchProblemOperationList = async ({ page = 1, pageSize = 25 }) => {
    await Api.get(
      "operation-problem-list",
      "configuracoesOmni",
      `?page=${page - 1}` +
        `&pageSize=${pageSize ? pageSize : 25}` +
        "&idPedido=" +
        idPedido,
      true
    )
      .then(({ Success, Result }) => {
        if (Success) {
          setProblemsOperationList(Result?.Registros);
          setTotalRegisters(Result?.TotalRegistros);
          setCurrentPage(page);
          setCurrentSizePerPage(pageSize);
          tableProblems();
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setLoadingProblemOperationList(false));
  };

  const handleAddProblem = useCallback(async () => {
    setRegistering(true);

    await Api.post(
      "create-operation-problem",
      "configuracoesOmni",
      {
        idPedido: idPedido,
        tipoProblema: problemType,
        motivo: motive,
        idPessoaLoja: idLoja,
        descricao: description,
        responsavel: responsable,
        status: "ABERTO",
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Registro de problema operacional realizado com sucesso!`,
            {
              severity: "success",
            }
          );
          handleClose();
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setRegistering(false));
  }, [
    idPedido,
    motive,
    description,
    problemType,
    responsable,
    snackbar,
    handleClose,
  ]);

  const handleEditProblem = useCallback(async () => {
    setUpdating(true);

    await Api.put(
      "edit-operation-problem",
      "configuracoesOmni",
      {
        idRegistroProblema: selectedOrder?.IdRegistroProblema,
        tipoProblema: problemType,
        motivo: motive,
        idPessoaLoja: idLoja,
        descricao: description,
        status: selectedStatus,
        ativo: isActive,
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Registro de problema operacional atualizado com sucesso!`,
            {
              severity: "success",
            }
          );
          setSelectedOrder(null);
          setShowDetail(false);
          setProblemType("");
          setMotive("");
          setDescription("");
          setHasChange(false);

          fetchProblemOperationList({
            page: 1,
            pageSize: currentSizePerPage,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setUpdating(false));
  }, [
    idPedido,
    motive,
    description,
    problemType,
    snackbar,
    handleClose,
    isActive,
    selectedStatus,
  ]);

  const handleGetProblem = async () => {
    setLoadingProblem(true);

    await Api.get(
      "operation-problem-list",
      "configuracoesOmni",
      "?page=0&idRegistroProblema=" + selectedOrder?.IdRegistroProblema,
      true
    )
      .then((res) => {
        if (res.Success) {
          setOccurences(res?.Result?.Registros[0]?.Atividades);
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });      })
      .finally(() => setLoadingProblem(false));
  };

  const handleActiveChange = useCallback((event) => {
    setIsActive(event.target.checked);
    setHasChange(true);
  }, []);

  const occurencesList = () => {
    return (
      <>
        {occurences?.length === 0 ? (
          <Typography
            variant="span"
            component="span"
            style={{ marginLeft: "0.5rem" }}
          >
            Não há ocorrências registradas para este problema operacional.
          </Typography>
        ) : (
          <>
            {occurences?.map((item) => (
              <Card
                key={item?.IdAtividade}
                classes={{ root: classes.cardRoot }}
                elevation={1}
              >
                <CardContent classes={{ root: classes.cardContentRoot }}>
                  <Grid container>
                    <Grid item xs={isMobile ? 12 : 6}>
                      <FormTextInput
                        label={"Responsável"}
                        value={item?.Responsavel}
                        disable={true}
                      />
                    </Grid>
                    <Grid item xs={isMobile ? 10 : 4}>
                      <FormTextInput
                        label={"Data Criação"}
                        value={moment(item?.DataOcorrenciaFormat).format(
                          "DD/MM/YYYY"
                        )}
                        disable={true}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        padding: 0,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Tooltip title="Editar Ocorrência">
                        <Button
                          onClick={() => {
                            setEditOccurence(item);
                            setOpenCreateOccurence(true);
                          }}
                          disabled={updating}
                        >
                          <Box
                            component={Edit}
                            position="relative"
                            top="-2px"
                            width={"1.6rem!important"}
                            height={"1.6rem!important"}
                          />
                        </Button>
                      </Tooltip>
                    </Grid>
                    <Grid iem xs={12} style={{ marginBottom: "-0.5rem" }}>
                      <FormGroup>
                        <FormLabel>Observação</FormLabel>
                        <TextField
                          placeholder="Observação"
                          value={item?.Observacao}
                          variant="outlined"
                          disabled={true}
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))}
          </>
        )}
      </>
    );
  };

  const inputForm = (isRequired, isDetail) => {
    return (
      <>
        <Grid
          container
          style={{ display: "flex", justifyContent: "space-between" }}
          hidden={!isDetail}
        >
          <Grid item xs={isMobile ? 12 : 6}>
            <FormTextInput
              label={"Razão Social"}
              value={selectedOrder?.Loja}
              disable={true}
            />
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <FormTextInput
              label={"Loja"}
              value={selectedOrder?.Apelido}
              disable={true}
            />
          </Grid>
        </Grid>
        <Grid
          container
          style={{ display: "flex", justifyContent: "space-between" }}
          hidden={!isDetail}
        >
          <Grid item xs={isMobile ? 12 : 6}>
            <FormTextInput
              label={"Número Pedido"}
              value={selectedOrder?.IdPedido}
              disable={true}
            />
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <FormTextInput
              label={"Data Abertura"}
              value={moment(selectedOrder?.DataAberturaFormat).format(
                "DD/MM/YYYY"
              )}
              disable={true}
            />
          </Grid>
        </Grid>
        <Grid
          container
          style={{ display: "flex", justifyContent: "space-between" }}
          hidden={!isDetail}
        >
          <Grid item xs={isMobile ? 12 : 6}>
            <FormTextInput
              label={"Responsável"}
              value={selectedOrder?.Responsavel}
              disable={true}
            />
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <FormGroup>
              <FormLabel>Ativo</FormLabel>
              <Switch
                checked={isActive}
                onChange={handleActiveChange}
                size="small"
              />
            </FormGroup>
          </Grid>
        </Grid>
        <Grid
          container
          style={{ display: "flex", justifyContent: "space-between" }}
          hidden={!isDetail}
        >
          <Grid item xs={isMobile ? 12 : 6}>
            <FormGroup>
              <FormControl variant="outlined" required={isRequired} fullWidth>
                <FormLabel>Tipo de Problema</FormLabel>
                <Select
                  fullWidth
                  variant="outlined"
                  label="Tipo de Problema"
                  value={problemType}
                  onChange={(e) => {
                    setProblemType(e.target.value);
                    setHasChange(true);
                  }}
                  IconComponent={KeyboardArrowDown}
                >
                  {listProblemTypes.map((problema, index) => (
                    <MenuItem key={index} value={problema.Valor}>
                      {problema.Descricao}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </FormGroup>
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <FormGroup>
              <FormControl variant="outlined" required={isRequired} fullWidth>
                <FormLabel>Status</FormLabel>
                <Select
                  fullWidth
                  variant="outlined"
                  label="Status"
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setHasChange(true);
                  }}
                  IconComponent={KeyboardArrowDown}
                >
                  {verifyStatus.map((status, index) => (
                    <MenuItem key={index} value={status.Valor}>
                      {status.Descricao}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </FormGroup>
          </Grid>
        </Grid>
        <FormGroup hidden={isDetail}>
          <FormLabel required={isRequired}>Responsável</FormLabel>
          <TextField
            placeholder="Responsável"
            value={responsable}
            onChange={(event) => {
              setResponsable(event.target.value);
            }}
            variant="outlined"
            disabled={registering}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 1000))
            }
          />
        </FormGroup>
        <FormGroup>
          <FormLabel required={isRequired}>Motivo</FormLabel>
          <TextField
            placeholder="Motivo"
            multiline
            rows={2}
            value={motive}
            onChange={(event) => {
              setMotive(event.target.value);
              setHasChange(true);
            }}
            variant="outlined"
            disabled={registering}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 2000))
            }
          />
        </FormGroup>
        <FormGroup hidden={isDetail}>
          <FormControl variant="outlined" required={isRequired} fullWidth>
            <FormLabel>Tipo de Problema</FormLabel>
            <Select
              fullWidth
              variant="outlined"
              label="Tipo de Problema"
              value={problemType}
              onChange={(e) => setProblemType(e.target.value)}
              IconComponent={KeyboardArrowDown}
            >
              {listProblemTypes.map((problema, index) => (
                <MenuItem key={index} value={problema.Valor}>
                  {problema.Descricao}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FormGroup>
        <FormGroup>
          <FormLabel required={isRequired}>Descrição</FormLabel>
          <TextField
            placeholder="Descrição"
            multiline
            rows={3}
            value={description}
            onChange={(event) => {
              setDescription(event.target.value);
              setHasChange(true);
            }}
            variant="outlined"
            disabled={registering}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 6000))
            }
          />
        </FormGroup>
        <Grid container hidden={!isDetail}>
          <Grid item xs={3} style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="h4" component="h4">
              Ocorrências
            </Typography>
            <Tooltip title="Registrar Ocorrência" style={{ marginLeft: 2 }}>
              <Button
                onClick={() => {
                  setOpenCreateOccurence(true);
                  setEditOccurence(null);
                }}
                disabled={updating}
              >
                <Box
                  component={Add}
                  position="relative"
                  top="-2px"
                  width={"1.6rem!important"}
                  height={"1.6rem!important"}
                />
              </Button>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <>{occurencesList()}</>
          </Grid>
        </Grid>
      </>
    );
  };

  const buttonsForm = (isCreating) => {
    return (
      <DialogActions>
        <Button
          component={Box}
          onClick={handleClose}
          disabled={registering || updating}
        >
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={isCreating ? handleAddProblem : handleEditProblem}
          disabled={validationButton || updating || registering}
        >
          {isCreating ? "Registrar" : "Atualizar"}
        </Button>
      </DialogActions>
    );
  };

  const tableProblems = () => {
    return (
      <TableRegistroProblemaPI
        dataTable={problemsOperationList}
        totalRegistros={totalRegisters}
        currentPage={currentPage}
        currentSizePerPage={currentSizePerPage}
        search={fetchProblemOperationList}
        setShowDetail={setShowDetail}
        setSelectedOrder={setSelectedOrder}
      />
    );
  };

  const addNewProblem = () => {
    return (
      <>
        <DialogTitle id="alert-dialog-title">
          <Grid container style={{ display: "flex", alignItems: "center" }}>
            <Grid item xs={10}>
              <Typography variant="h3" component="h3">
                Registrar Problema Operacional
              </Typography>
            </Grid>
            <Grid
              item
              xs={isMobile ? 12 : 2}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Tooltip title="Voltar" style={{ marginLeft: 2 }}>
                <Button
                  onClick={() => {
                    setOpenCreateProblem(false);
                    setMotive("");
                    setDescription("");
                    setProblemType("");
                  }}
                  disabled={registering}
                >
                  <Box
                    component={ArrowForward}
                    position="relative"
                    top="-2px"
                    width={"1.6rem!important"}
                    height={"1.6rem!important"}
                  />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ padding: "0 1.5rem 1.5rem" }}>
          {inputForm(true, false)}
          {registering && (
            <div>
              <span>Registrando problema operacional...</span>
              <LinearProgress />
            </div>
          )}
        </DialogContent>
        <>{buttonsForm(true)}</>
      </>
    );
  };

  const showListProblems = () => {
    return (
      <>
        <DialogTitle id="alert-dialog-title" style={{ marginBottom: "-1rem" }}>
          <Grid container style={{ display: "flex", alignItems: "center" }}>
            {showDetail && selectedOrder ? (
              <>
                <Grid item xs={isMobile ? 12 : 10}>
                  <Typography variant="h3" component="h3">
                    Detalhes do Problema
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={isMobile ? 12 : 2}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Tooltip title="Voltar" style={{ marginLeft: 2 }}>
                    <Button
                      onClick={() => {
                        const listItems = problemsOperationList?.map((item) => {
                          if (
                            item?.IdRegistroProblema ===
                            selectedOrder?.IdRegistroProblema
                          ) {
                            return {
                              ...item,
                              Atividades: occurences,
                            };
                          } else {
                            return item;
                          }
                        });
                        setProblemsOperationList(listItems);
                        setSelectedOrder(null);
                        setShowDetail(false);
                        setProblemType("");
                        setMotive("");
                        setDescription("");
                        setHasChange(false);
                        tableProblems();
                      }}
                      disabled={registering}
                    >
                      <Box
                        component={ArrowForward}
                        position="relative"
                        top="-2px"
                        width={"1.6rem!important"}
                        height={"1.6rem!important"}
                      />
                    </Button>
                  </Tooltip>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={isMobile ? 12 : 10}>
                  <Typography variant="h3" component="h3">
                    Problemas Operacionais
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={isMobile ? 12 : 2}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Tooltip
                    title="Registrar Problema Operacional"
                    style={{ marginLeft: 2 }}
                  >
                    <Button
                      onClick={() => setOpenCreateProblem(true)}
                      disabled={loadingProblemOperationList}
                    >
                      <Box
                        component={Add}
                        position="relative"
                        top="-2px"
                        width={"1.6rem!important"}
                        height={"1.6rem!important"}
                      />
                    </Button>
                  </Tooltip>
                </Grid>
              </>
            )}
          </Grid>
        </DialogTitle>
        <PerfectScrollbar>
          <DialogContent
            style={{ overflowY: "hidden", padding: "0 1.5rem 1.5rem" }}
          >
            {!loadingProblemOperationList && (
              <>
                {problemsOperationList?.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography variant="h4" component="h4">
                      Nenhum problema operacional registrado para este pedido.
                    </Typography>
                  </Grid>
                ) : (
                  <>
                    {showDetail && selectedOrder ? (
                      <>
                        {loadingProblem ? (
                          <div>
                            <span>
                              Buscando detalhes do problema operacional...
                            </span>
                            <LinearProgress />
                          </div>
                        ) : (
                          <>{inputForm(false, true)}</>
                        )}
                      </>
                    ) : (
                      <>{tableProblems()}</>
                    )}
                  </>
                )}
              </>
            )}
            {loadingProblemOperationList && (
              <div>
                <span>Buscando problemas operacionais...</span>
                <LinearProgress />
              </div>
            )}
            {updating && (
              <div>
                <span>Atualizando problema operacional...</span>
                <LinearProgress />
              </div>
            )}
          </DialogContent>
        </PerfectScrollbar>
        <>{showDetail && selectedOrder && buttonsForm(false)}</>
      </>
    );
  };

  useEffect(() => {
    if (openCreateProblem) {
      setValdationButton(
        registering ||
          motive === "" ||
          description === "" ||
          problemType === "" ||
          responsable === ""
      );
    }
  }, [
    openCreateProblem,
    registering,
    motive,
    description,
    problemType,
    responsable,
  ]);

  useEffect(() => {
    if (showDetail) {
      setValdationButton(!hasChange);
    }
  }, [showDetail, hasChange]);

  useEffect(() => {
    if (selectedOrder) {
      setProblemType(selectedOrder?.TipoProblema);
      setSelectedStatus(selectedOrder?.Status);
      setMotive(selectedOrder?.Motivo);
      setDescription(selectedOrder?.Descricao);
      setIsActive(selectedOrder?.Ativo);
      setOccurences(selectedOrder?.Atividades);

      if (statusList?.length !== 0) {
        const list = [];
        statusList?.map((item) => {
          if (selectedOrder?.Status === "ABERTO") {
            if (
              item?.Valor === "NAO-TRATADO" ||
              item?.Valor === "FECHADO" ||
              item?.Valor === "ABERTO"
            ) {
              list?.push(item);
            }
          } else if (selectedOrder?.Status === "FECHADO") {
            if (item?.Valor === "TRATADO-ERRO" || item?.Valor === "FECHADO") {
              list?.push(item);
            }
          } else {
            list.push(item);
          }
        });
        setVerifyStatus(list);
      }
    }
  }, [selectedOrder]);

  useEffect(() => {
    fetchProblemOperationList({
      page: 1,
      pageSize: currentSizePerPage,
    });
    fetchTypeProblemsAndStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {openCreateOccurence && (
        <DialogCreateOccurence
          onCloseDialog={(value) => {
            setOpenCreateOccurence(false);
            if (value === "creating" || value === "editing") {
              handleGetProblem();
            }
          }}
          openCreateOccurence={openCreateOccurence}
          idRegistroProblema={selectedOrder?.IdRegistroProblema}
          editOccurence={editOccurence}
        />
      )}
      <Dialog
        open={open}
        maxWidth="md"
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {openCreateProblem ? <>{addNewProblem()}</> : <>{showListProblems()}</>}
      </Dialog>
    </>
  );
}

export { DialogRegistroProblemaPI };
